import { type FC, useCallback } from "react";

import { Checkbox } from "@snapchat/snap-design-system";

import { type MyLensesLensStatus } from "../../../../gql-generated/types";
import { LensStatusIndicator } from "../../../../lens/components/shared";
import { useLensStatus } from "../../../../lens/hooks";
import { Flexbox } from "../../../../shared/components";
import { useLensFilterByStatus } from "../../../hooks";

import { StatusName, lensFilterItemContainer, widthName } from "./LensFilterItem.styles";

interface LensFilterItemProps {
    value: MyLensesLensStatus;
}

export const LensFilterItem: FC<LensFilterItemProps> = ({ value }) => {
    const { selectedAll, filterByStatus, updateFilter } = useLensFilterByStatus();
    const { color, name } = useLensStatus(value);
    const checked = selectedAll || filterByStatus.includes(value);
    const onClick = useCallback(() => {
        updateFilter(value);
    }, [updateFilter, value]);

    return (
        <Flexbox
            alignItems="center"
            justifyContent="space-between"
            className={lensFilterItemContainer}
            onClick={onClick}
        >
            <Checkbox value={checked} />
            <Flexbox alignItems="center" className={widthName}>
                <LensStatusIndicator background={color} />
                <StatusName>{name}</StatusName>
            </Flexbox>
        </Flexbox>
    );
};
